import CardHeader from "./CardHeader";
import CardBody from "./CardBody";
import CardFooter from "./CardFooter";
import "./Card.scss";
import { Link } from "react-router-dom";

export default function Card(props) {
  return (
    <div
      className={
        props.className === undefined
          ? "card-custom"
          : "card-custom " + props.className
      }
    >
      {props.children}
      {/* <Link to={"/assistant/dashboardAssistant"} >لینک موقت برو به دستیار  </Link> */}
    </div>
  );
}

export { CardHeader, CardBody, CardFooter };
